<!--
  @文件名:    须知
  @file:    notice
  @author:
  @date:    2021/4/29 0029
  @time:    10:43
  @require:
-->
<template>
  <div class="Notice">
    <app-breadcrumb />
    <div>
      <el-form style="padding: 0 20px" label-position="right" label-width="200px">
        <h2 class="h2right">须知 </h2>
        <div v-for="(iframe, index) in iframeList" :key="iframe.id">
          <hr style="border: 1px dashed ; width: 100%;height: 1px;" />
          <h1>{{ iframe.name }}</h1>
          <div :id="iframe.id">
            <iframe :ref="'iframe_' + index" :src="iframe.src" width="100%" :height="iframe.height +'px'" frameborder="0"
              @load="onIframeLoad(index)"></iframe>
          </div>
          <el-checkbox :disabled="iframe.disabled" v-model="iframe.checked" style="margin: 15px auto 0"><span
              style="color: red;font-weight: 700;font-size: 20px">我已阅读并同意此协议</span></el-checkbox>
              <p style="margin-top: 0;">请阅读至末尾</p>
        </div>
        <hr style="border: 1px dashed ; width: 100%;height: 1px;" />
      </el-form>
      <el-button class="el-icon-check" type="success" @click="toNext"
        style="margin-top: 40px;margin-bottom: 20px">我已知悉并同意以上协议</el-button>
    </div>
  </div>
</template>
<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';
export default {
  name: "Notice",
  directives: {},
  components: {},
  props: [],
  data() {
    return {
      iframeList: [
        { id: 'CorporateCodeofConduct', name: '公司行为规范', src: '/static/html/CorporateCodeofConduct.html', checked: false, disabled: true, height: 500 },
        { id: 'DistributorNotice', name: '经销商须知', src: '/static/html/DistributorNotice.html', checked: false, disabled: true, height: 500 },
        { id: 'DealerContract', name: '经销商合同', src: '/static/html/DealerContract.html', checked: false, disabled: true, height: 500 }
      ]
    }
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {},
  created() {

  },
  mounted() {

  },
  beforeCreate() {
  },
  beforeMount() {
  },
  beforeUpdate() {
  },
  updated() {
  },beforeDestroy() {
    // 清理所有iframe的事件监听器
    this.iframeList.forEach((_, index) => {
      const iframeEl = this.$refs[`iframe_${index}`];
      if (iframeEl && iframeEl._scrollHandler) {
        const iframeWindow = iframeEl[0].contentWindow;
        iframeWindow.removeEventListener('scroll', iframeEl._scrollHandler);
        delete iframeEl._scrollHandler;
      }
    });
  },
  destroyed() {
  },
  // 如果页面有keep-alive缓存功能，这个函数会触发
  activated() {
  },
  methods: {
    onIframeLoad(index) {
      const iframeEl = this.$refs[`iframe_${index}`];
      if (!iframeEl) return;
      // console.log(iframeEl, 'iframeEl');
      
      const iframeWindow = iframeEl[0].contentWindow;
      // console.log(iframeWindow, 'iframeWindow');
      // 创建滚动事件处理函数
      const scrollHandler = () => {
        const iframeDoc = iframeWindow.document;
        const scrollTop = iframeDoc.documentElement.scrollTop || iframeDoc.body.scrollTop;
        const scrollHeight = iframeDoc.documentElement.scrollHeight || iframeDoc.body.scrollHeight;
        // console.log(scrollTop, scrollHeight, 'scrollTop, clientHeight');
        if (scrollTop >= scrollHeight - 200 - iframeWindow.innerHeight) {
          this.iframeList[index].disabled = false; // 滚动到页面底部后，启用复选框
          iframeWindow.removeEventListener('scroll', scrollHandler);
        }
        
      };
      
      // 存储事件监听器到DOM元素，以便后续清理
      iframeEl._scrollHandler = scrollHandler;
      iframeWindow.addEventListener('scroll', scrollHandler);
    },
    toNext() {
      if (!this.iframeList[0].checked) {
        return this.$message.error('请同意公司行为规范!')
      }
      if (!this.iframeList[1].checked) {
        return this.$message.error('请同意经销商须知!')
      }
      if (!this.iframeList[2].checked) {
        return this.$message.error('请同意经销商合同!')
      }
      this.$router.push('/member/bussiness-viewedit')
    }
  }
}
</script>
<style scoped>
.h2right {
  float: left;
  color: #F39F43;
}
</style>
